import { carouselData } from '@/mocks/homeData';

const carouselImages = [
  'https://readdy.ai/api/search-image?query=Summer%20beach%20scene%20with%20colorful%20manga%20character%20illustrations%20enjoying%20beach%20activities%2C%20bright%20warm%20sunlight%2C%20vibrant%20coral%20and%20golden%20tones%2C%20anime%20art%20style%2C%20festive%20atmosphere%2C%20clean%20composition&width=1200&height=500&seq=carousel-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Creative%20workspace%20scene%20with%20drawing%20tablet%20and%20manga%20storyboard%20sketches%2C%20warm%20desk%20lamp%20lighting%2C%20artistic%20atmosphere%2C%20focused%20hands%20drawing%2C%20cozy%20studio%20vibe%2C%20soft%20natural%20tones&width=1200&height=500&seq=carousel-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Vintage%20library%20hidden%20reading%20nook%20with%20sunlight%20streaming%20through%20stained%20glass%20window%20onto%20aged%20manga%20books%2C%20warm%20golden%20light%2C%20dust%20motes%2C%20nostalgic%20atmosphere%2C%20quiet%20cozy%20vibe&width=1200&height=500&seq=carousel-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cinema%20silver%20screen%20blending%20with%20floating%20manga%20comic%20panels%20in%20creative%20visual%2C%20warm%20theater%20lighting%2C%20film%20reels%20and%20manga%20pages%20intertwining%2C%20artistic%20double%20exposure%20effect&width=1200&height=500&seq=carousel-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Cozy%20reading%20corner%20at%20night%20with%20open%20manga%20book%2C%20steaming%20tea%20cup%2C%20handwritten%20notes%20and%20sticky%20notes%2C%20warm%20ambient%20lighting%2C%20peaceful%20night%20atmosphere%20through%20window%2C%20comfortable%20chair&width=1200&height=500&seq=carousel-05&orientation=landscape',
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            编辑团队为你精心策划的深度专题内容
          </p>
        </div>

        <div className="flex flex-col gap-6 md:gap-8">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className={`group flex flex-col ${
                i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-5 md:gap-8 rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer`}
            >
              <div className="w-full lg:w-2/5 relative aspect-[16/9] lg:aspect-auto bg-background-200 overflow-hidden">
                <img
                  src={carouselImages[i]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-500/90 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>

              <div className="flex-1 p-5 md:p-8 flex flex-col justify-center gap-3">
                <h3 className="font-heading font-bold text-lg md:text-xl lg:text-2xl text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm md:text-base font-medium text-foreground-700">
                  {item.subtitle}
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <div className="pt-1">
                  <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    查看详情 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}